// Web shim for `react-native-webview`. Renders the target URL in an <iframe>.
// Native-only props (onShouldStartLoadWithRequest, injectedJavaScript*,
// onMessage, originWhitelist, renderLoading, …) are accepted but ignored — a
// cross-origin iframe cannot intercept navigations, inject scripts, or postMessage
// back. Used by place-detail-screen (embeds provider place pages); the map
// popover's injection-based WebView is guarded off on web (see place-popover).
//
// Caveat: some providers (naver/kakao/google) may send X-Frame-Options /
// frame-ancestors that refuse framing; that surfaces as a blank frame.
import React from 'react'
import { View } from 'react-native'

export const WebView = React.forwardRef(function WebView(props, ref) {
  const { source, style } = props
  const uri = (source && source.uri) || ''
  return (
    <View style={[{ flex: 1 }, style]}>
      <iframe
        ref={ref}
        src={uri}
        title='webview'
        style={{ border: 0, width: '100%', height: '100%', display: 'block' }}
        allow='geolocation; clipboard-write'
      />
    </View>
  )
})

export default WebView
